import { Component, Input } from '@angular/core';
import { ComponentBase } from '../../models/ComponentBase';
import { UpsertCustomerRequest } from '../../WebApiClient';

@Component({
    selector: 'app-edit-customer-inner',
    templateUrl: './edit-customer-inner.component.html',
    styleUrls: ['./edit-customer-inner.component.scss'],
    standalone: false
})
export class EditCustomerInnerComponent extends ComponentBase {

    constructor() { super() }


    @Input()
    customer: UpsertCustomerRequest = new UpsertCustomerRequest();

}
